import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from './services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  lang = "en";
  langLabel = "";
  

  constructor(
      private router: Router,
      private localStorageService: LocalStorageService,
      public translate: TranslateService,
      private title: Title
    ) {
     
      if (this.localStorageService.get("lang") !== null) {
        this.translate.setDefaultLang(this.localStorageService.get("lang"));
        let label = this.localStorageService.get("lang");
        if (label == "en") {
          this.langLabel = "en"
        } else if (label == "fr") {
          this.langLabel = "fr"
        } else {
          this.langLabel = "en";
        }
      } else {
        this.langLabel = "en";
        this.localStorageService.set("lang", "en");
        this.translate.setDefaultLang("en");
      }
      this.setTitle();
    }


    

    setTitle() {
      this.translate.get("PUROLATOR_TITLE").subscribe(tit=> {
        this.title.setTitle(tit);
      });
    }

    persist(key: string, value: any) {
      this.localStorageService.set(key, value);
    }

    

    langClick(event: any) {
      this.translate.setDefaultLang(event);
      this.setTitle();
      this.localStorageService.set("lang", event);
      window.location.reload();
    }
}
